// assets
import { IconArchive } from '@tabler/icons';
import permissioncheck from 'utils/permissioncheck';

// ==============================|| UTILITIES MENU ITEMS ||============================== //
const children = [
  {
    id: 'archive',
    perm: 'superadmin',
    title: 'Data Arsip',
    type: 'item',
    url: '/archive',
    icon: IconArchive,
    breadcrumbs: false
  }
];
const data = {
  id: 'archive',
  title: '',
  type: 'group',
  children: []
};

children.forEach((element) => {
  if (permissioncheck(element.perm)) {
    data.children.push(element);
  }
});

export default data;
